import { Theme, css } from '@emotion/react';

export const footerContainer = ({ breakpoints, colors, spacing }: Theme) => css`
  padding: ${spacing(2)}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  /* inset border on mobile */
  ${breakpoints.only('xs')} {
    &::before {
      background: ${colors.borderDefault};
      content: ' ';
      top: 0;
      right: ${spacing(2)}px;
      left: ${spacing(2)}px;
      height: 1px;
      position: absolute;
    }
  }

  ${breakpoints.up('sm')} {
    border-top: 1px solid ${colors.borderDefault};
    justify-content: normal;
    gap: ${spacing(1)}px;
  }
`;
